import { isDesktop } from "coremh/components/utils";

const $ratingsReviewCarousel = $(".js-ratings-reviews-carousel");

/**
* Initializes the reviews carousel using the Slick carousel plugin.
* Applies carousel settings to each element in the $ratingsReviewCarousel collection if present.
* Configures the carousel to show 3.5 slides with arrows on desktop, and 1.1 slides with dots on mobile devices.
*
* @param {jQuery} carousel - The jQuery object representing the carousel container(s) to initialize.
*/
const initReviewsCarousel = () => {
    if ($ratingsReviewCarousel.length > 0) {
        $ratingsReviewCarousel.each(function () {
            $(this).slick({
                slidesToShow: 3.5,
                arrows: true,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1.1,
                            arrows: false,
                            dots: true
                        }
                    }
                ],
            });
        });
    }
};

/**
* Initializes the logo carousel for ratings and reviews on mobile devices.
* Applies the Slick carousel plugin to elements with the class 'js-rating-reviews-logo-carousel'
* only when the page is not viewed on a desktop device.
*
* @param {HTMLElement|jQuery} carousel - The carousel element to initialize (currently unused).
*/
const initLogoCarousel = () => {
    const $ratingsReviewLogoCarousel = $(".js-rating-reviews-logo-carousel");

    if ($ratingsReviewLogoCarousel.length > 0 && !isDesktop()) {
        $ratingsReviewLogoCarousel.each(function () {
            $(this).slick({
                mobileFirst: true,
                slidesToShow: 2.15,
                arrows: false,
                infinite: false
            });
        });
    }
};

/**
* Initializes click event handlers for review logo blocks in the reviews carousel.
* When a logo block is clicked, the carousel navigates to the corresponding review slide
* and smoothly scrolls the page to the carousel's position.
*
* @function
* @returns {void}
*/
const initEvents = () => {
    $(".rating-reviews-logo-block").on("click", (e) => {
        let reviewID = $(e.target).parents(".rating-reviews-logo-block").data("review-id");
        let index = $(`.ratings-reviews-block[data-review-id="${reviewID}"]`).parents(".slick-slide").data("slick-index");

        if ($ratingsReviewCarousel.length && index !== undefined) {
            $ratingsReviewCarousel.slick("slickGoTo", index);

            $("html, body").animate({
                "scrollTop": $ratingsReviewCarousel.offset().top
            }, 400);
        }
    });
};

export default function () {
    initReviewsCarousel();
    initLogoCarousel();
    initEvents();
}
